/* eslint-env es2020 */
import { normalizeRpcEndpoint } from "./stringUtils";
import { postJson } from "./jsonUtils";

export async function readTableRows(rpc, { code, scope, table, limit = 100, lower_bound, reverse = false, index_position, key_type }) {
  const rpcBase = normalizeRpcEndpoint(rpc);
  const body = {
    json: true,
    code,
    scope,
    table,
    limit,
    reverse: !!reverse,
    show_payer: false,
  };
  if (lower_bound !== undefined && lower_bound !== null && String(lower_bound).trim() !== "") body.lower_bound = lower_bound;
  if (index_position) body.index_position = index_position;
  if (key_type) body.key_type = key_type;
  return await postJson(`${rpcBase}/v1/chain/get_table_rows`, body);
}

export async function fetchAllRows(rpc, params) {
  const out = [];
  let lower = params.lower_bound;
  for (let i = 0; i < 10000; i++) {
    const resp = await readTableRows(rpc, {...params, lower_bound: lower, limit: params.limit ?? 1000 });
    const rows = resp?.rows || [];
    out.push(...rows);
    if (!resp?.more) break;
    const next = resp?.next_key;
    if (next === undefined || next === null || String(next) === "") {
      // fallback: move lower bound by last primary key if present
      break;
    }
    lower = next;
  }
  return out;
}

export function derivePoolScope(poolRow) {
  const h = poolRow?.poolHash ?? poolRow?.poolhash ?? poolRow?.pool_hash;
  if (h === undefined || h === null) return "";
  return String(h);
}

const MASK_64 = (1n << 64n) - 1n;

/** EOSIO/XPR account name → uint64 (matches contract name encoding). */
export function nameToUint64(name) {
  const s = String(name || "").trim();
  if (!s || s.length > 13) return 0n;
  let value = 0n;
  for (let i = 0; i < 13; i++) {
    let c = 0n;
    if (i < s.length) {
      const ch = s.charCodeAt(i);
      if (ch === 46) c = 0n;
      else if (ch >= 49 && ch <= 53) c = BigInt(ch - 48);
      else if (ch >= 97 && ch <= 122) c = BigInt(ch - 91);
      else return 0n;
      if (i === 12 && c > 15n) return 0n;
    }
    if (i < 12) {
      value = (value << 5n) | (c & 0x1fn);
    } else {
      value = (value << 4n) | (c & 0xfn);
    }
    value &= MASK_64;
  }
  return value & MASK_64;
}

export function postWalletUiCleanup() {
  try {
    const b = document.body;
    if (b?.style?.overflow) b.style.overflow = "";
    const h = document.documentElement;
    if (h?.style?.overflow) h.style.overflow = "";
    // Force reflow + resize
    // eslint-disable-next-line no-unused-expressions
    b && b.offsetHeight;
    requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
    setTimeout(() => window.dispatchEvent(new Event("resize")), 50);
  } catch {
    // ignore
  }
}
